import {Link} from 'react-router-dom'
import React from 'react'
import styled from 'styled-components'

import {Row} from '../Box'
import Image from '../Image'
import menuIcon from './menu-icon.svg'
import webTipsIcon from './tips.svg'
import webTipsMobileIcon from './m-tips.svg'
import webInfoIcon from './info.svg'
import webInfoMobileIcon from './m-info.svg'

import kidsIcon from './kids.svg'
import lWebKids from './l-web-kids.svg'
import lWebTips from './l-web-tips.svg'
import lWebInfo from './l-web-info.svg'
import kidsMobileIcon from './m-kids.svg'
import lKidsMobileIcon from './m-l-web-kids.svg'

import webIcon from './web.svg'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const Bar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  height: calc(64px + env(safe-area-inset-top));
  background: #172129;
  color: #AEBFCC;
  display: flex;
  padding-bottom: 0px;
  flex-direction: row;
`

const BarTips = styled(Bar)`
  background: #1A4C7A;
`

const KidsBar = styled(Bar)`
  background: #598CC4;
`

const HomeButtonWebContainer = styled.button`
  width: 145px;
  height: calc(70px + env(safe-area-inset-top));
  object-fit: contain;
  border-radius: 0 0 57px 0;
  box-shadow: 0 8px 40px 0 rgba(194, 111, 35, 0.2), 0 16px 80px 0 rgba(194, 111, 35, 0.2);
  background-image: linear-gradient(244deg, #ff9921, #f58238);
  border: none;
  z-index: 1;

  font-family: Pacifico;
  font-size: 33px;
  color: #ffffff;
  padding: 0 30px;
  text-align: left;
  @media(min-width: 900px) {
    margin-right: 65px;
  }
`

interface IHomeButtonProps {
  showHamburger?: boolean,
}

const showHamburger = (props: any) => {
  return props.showHamburger === true || props.showHamburger === undefined
}

const HomeButtonTipsContainer = styled(HomeButtonWebContainer)`
  cursor: pointer;
  width: ${(props: IHomeButtonProps) => showHamburger(props) ? '300px' : '230px'};
  position: relative;

  font-family: Nunito;
  font-size: 34px;
  font-weight: 900;
  padding: 0 0 0 ${(props: IHomeButtonProps) => showHamburger(props) ? '90px' : '30px'};
  
  ${(props: IHomeButtonProps) => showHamburger(props) ? '' : 'pointer-events: none'}

  ::before {
    content: "";
    position: absolute;
    ${(props: IHomeButtonProps) => showHamburger(props) ? 'left: 30px;' : ''}
    top: 20px;
    ${(props: IHomeButtonProps) => showHamburger(props) ? 'width: 36px;' : ''}
    height: 30px;
    margin-top: env(safe-area-inset-top);
    ${(props: IHomeButtonProps) => showHamburger(props) ? `background: url(${menuIcon});` : ''}
  }


  @media (max-width: 500px) {
    width: 200px;
  }
  `


const HomeButtonKidsContainer = styled(HomeButtonTipsContainer)`
  width: 380px;
  @media (max-width: 500px) {
    width: 300px;
  }
`

const TitleButton = (url: any, mobileUrl: any) => styled.button`
    background: url(${url});
    background-repeat: no-repeat;
    width: 300px;
    height: 65px;
    border: none;
    z-index: 1;
    background-position-y: center;
    margin-top: env(safe-area-inset-top);
    margin-right: 65px;
    color: #ffffff;
    padding: 0 30px;
    text-align: left;
    @media (max-width: 500px) {
      width: 170px;
      background: url(${mobileUrl});
      background-repeat: no-repeat;
      background-position-y: center;
    }
`

const WebTipsTitle = TitleButton(lang === 'es' ? lWebTips : webTipsIcon, webTipsMobileIcon)
const WebInfoTitle = TitleButton(lang === 'es' ? lWebInfo : webInfoIcon, webInfoMobileIcon)
const KidsTitle = TitleButton(lang === 'es' ? lWebKids : kidsIcon, lang === 'es' ? lKidsMobileIcon : kidsMobileIcon)
const WebTitle = TitleButton(webIcon, webIcon)

const Button = styled.div<{ active?: boolean }>`
  font-family: Nunito;
  font-size: 22px;
  font-weight: 900;
  color: ${({active}) => active ? '#FC9426' : '#AEBFCC'};
  margin: 15px 25px;
  margin-top: calc(15px + env(safe-area-inset-top));

  @media (max-width: 900px) {
    display: none;
  }
`

const WhiteButton = styled.div<{ active?: boolean }>`
  font-family: Nunito;
  font-size: 22px;
  font-weight: 900;
  color: ${({active}) => active ? 'white' : '#CFE3FA'};
  align-self: center;
  margin-left: 9px;
  margin-right: 29px;


  @media (max-width: 900px) {
    display: none;
  }
  
  @media only screen
  and (min-device-width : 768px)
  and (max-device-width : 1024px)
  and (orientation : landscape) { 
    font-size: 18px;
  }

  @media only screen
  and (min-width: 1024px)
  and (max-height: 1366px)
  and (orientation: portrait)
  and (-webkit-min-device-pixel-ratio: 1.5) {
    font-size: 18px;
  }
`

const ButtonImg = styled(Image)`
  width: 38px;
  height: 38px;
  align-self: center;

  @media (max-width: 900px) {
    display: none;
  }
`

const KidsButton = (({text, name, active, link}: any) => {
  return (
    <Row center>
      <Link to={link}>
        <Row center>
          <ButtonImg name={name}/>
          <WhiteButton active={active} >
            <SiteDiv>{text}</SiteDiv>
          </WhiteButton>
        </Row>
      </Link>
    </Row>
  )
})

const SiteDiv = styled.div`
  display: inline;
  font-size: 18px;
  @media (max-width: 900px) {
    display: none;
  }
`



export const Nav = {
  Bar,
  BarTips,
  KidsButton,
  KidsBar,
  Button,
  WebTipsTitle,
  HomeButtonTips: (props: any) =>
    <HomeButtonTipsContainer {...props}>
      <WebTipsTitle/>
    </HomeButtonTipsContainer>,
  HomeButtonInfo: (props: any) =>
    <HomeButtonTipsContainer {...props}>
      <WebInfoTitle/>
    </HomeButtonTipsContainer>,
  KidsSite: (props: any) =>
    <HomeButtonKidsContainer {...props}>
      <KidsTitle/>
    </HomeButtonKidsContainer>,
  HomeButtonWeb: () => <HomeButtonWebContainer><WebTitle/></HomeButtonWebContainer>,
}



// WEBPACK FOOTER //
// ./src/atoms/Nav/index.tsx